const PendingWFH = () => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.1"
    //   width="20"
    //   height="20"
    //   x="0"
    //   y="0"
    //   viewBox="0 0 2000 2000"
    // >
    //   <g>
    //     <path
    //       d="M1892.536 1940.046H107.466C48.208 1940.046 0 1891.838 0 1832.585V668.749c0-38.793 21.009-74.69 54.83-93.69L947.365 73.633c32.469-18.238 72.805-18.238 105.27 0l892.536 501.426c33.818 18.995 54.829 54.897 54.829 93.69v1163.836c0 59.253-48.208 107.461-107.464 107.461zM1000.002 124.253c-7.302 0-14.602 1.83-21.116 5.487L86.35 631.166c-13.567 7.62-21.995 22.024-21.995 37.583v1163.836c0 23.768 19.34 43.105 43.11 43.105h1785.071c23.77 0 43.107-19.337 43.107-43.105V668.749c0-15.563-8.427-29.963-21.993-37.583L1021.115 129.74c-6.511-3.657-13.813-5.487-21.113-5.487z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M482.458 1879.724c-17.772 0-32.178-14.408-32.178-32.178v-644.204c0-17.77 14.406-32.178 32.178-32.178s32.178 14.408 32.178 32.178v644.204c0 17.77-14.406 32.178-32.178 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M795.268 1588.594H494.846c-17.772 0-32.178-14.408-32.178-32.178s14.406-32.178 32.178-32.178h300.422c17.772 0 32.178 14.408 32.178 32.178 0 17.771-14.406 32.178-32.178 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M795.268 1879.724c-17.772 0-32.178-14.408-32.178-32.178v-291.13c0-17.77 14.406-32.178 32.178-32.178s32.178 14.408 32.178 32.178v291.13c0 17.77-14.406 32.178-32.178 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M1075.193 1879.724h-29.075a32.176 32.176 0 0 1-29.609-19.581l-115.537-271.549H745.714c-17.772 0-32.178-14.408-32.178-32.178s14.406-32.178 32.178-32.178h157.571a60.767 60.767 0 0 1 56.001 37.033l108.11 254.097h7.797c15.233 0 28.861-7.18 37.391-19.699 8.396-12.322 10.15-27.327 4.839-41.236l-116.837-270.445a37.06 37.06 0 0 0-34.044-22.378H798.365c-45.833 0-72.451-18.783-86.71-34.538-31.137-34.406-29.884-80.857-29.091-91.864v-226.161c0-17.77 14.406-32.178 32.178-32.178s32.178 14.408 32.178 32.178v227.473c0 1.068-.053 2.136-.159 3.201-.635 7.589.383 30.874 12.797 44.374 8.145 8.854 20.838 13.159 38.806 13.159H966.54a101.375 101.375 0 0 1 93.12 61.21l117.079 271.003c.141.33.279.66.408.99a109.13 109.13 0 0 1-11.381 101.452c-20.399 29.939-54.261 47.815-90.573 47.815z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M745.714 1588.594c-162.903 0-295.435-132.53-295.435-295.435v-246.221c0-90.324 73.483-163.804 163.807-163.804 25.542 0 50.023 5.723 72.762 17.016 15.918 7.903 22.415 27.213 14.512 43.129-7.905 15.916-27.211 22.425-43.131 14.51-13.767-6.835-28.619-10.299-44.142-10.299-54.837 0-99.451 44.614-99.451 99.449v246.221c0 127.416 103.661 231.079 231.079 231.079 17.772 0 32.178 14.408 32.178 32.178s-14.406 32.177-32.179 32.177zM612.537 866.357c-84.346 0-152.965-68.618-152.965-152.963s68.62-152.967 152.965-152.967c84.347 0 152.967 68.622 152.967 152.967s-68.62 152.963-152.967 152.963zm0-241.575c-48.86 0-88.609 39.751-88.609 88.611S563.677 802 612.537 802s88.611-39.747 88.611-88.607-39.751-88.611-88.611-88.611zM1454.958 1879.724c-17.772 0-32.178-14.408-32.178-32.178v-631.815c0-17.77 14.406-32.178 32.178-32.178s32.178 14.408 32.178 32.178v631.815c0 17.77-14.406 32.178-32.178 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M1541.675 1879.724h-278.741c-17.772 0-32.178-14.408-32.178-32.178s14.406-32.178 32.178-32.178h278.741c17.772 0 32.178 14.408 32.178 32.178.001 17.77-14.405 32.178-32.178 32.178zM1430.18 1167.707h-250.868c-17.772 0-32.178-14.408-32.178-32.178 0-17.771 14.406-32.178 32.178-32.178h250.868c17.772 0 32.178 14.408 32.178 32.178 0 17.771-14.406 32.178-32.178 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M1430.255 1164.989c-2.757 0-5.558-.357-8.347-1.104-17.167-4.6-27.354-22.244-22.755-39.409l64.929-242.321c4.602-17.165 22.254-27.347 39.41-22.755 17.167 4.6 27.354 22.244 22.755 39.409l-64.929 242.321c-3.854 14.377-16.856 23.859-31.063 23.859z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M1541.675 1247.909H902.402a79.947 79.947 0 0 1-43.683-12.951l-235.843-153.297c-14.901-9.686-19.129-29.617-9.443-44.52 9.688-14.895 29.621-19.125 44.516-9.443L893.795 1181a15.714 15.714 0 0 0 8.606 2.553h639.274c17.772 0 32.178 14.408 32.178 32.178.001 17.77-14.405 32.178-32.178 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //     <path
    //       d="M1074.009 1247.909c-17.772 0-32.178-14.408-32.178-32.178v-43.015c0-18.312-14.895-33.207-33.203-33.207h-40.201a139.853 139.853 0 0 1-73.726-20.991c-.389-.24-.774-.487-1.151-.746l-238.935-162.56c-14.692-9.997-18.5-30.01-8.504-44.704 9.993-14.694 30.012-18.505 44.704-8.504l238.316 162.139a75.565 75.565 0 0 0 39.295 11.01h40.201c53.794 0 97.559 43.766 97.559 97.563v43.015c.001 17.77-14.405 32.178-32.177 32.178z"
    //       fill="#ffffff"
    //       opacity="1"
    //       data-original="#ffffff"
    //       stroke="#ffffff"
    //       strokeWidth="2"
    //     ></path>
    //   </g>
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 8.467 8.467"
    >
      <g>
        <path
          d="M4.1.57.655 2.69c-.301.185-.023.637.278.452l.391-.241v4.255a.8.8 0 0 0 .797.794h4.238a.8.8 0 0 0 .797-.794V2.902l.39.24c.302.185.58-.267.279-.452L4.378.57a.25.25 0 0 0-.278 0zm.139.537 2.387 1.468v4.58a.26.26 0 0 1-.267.265H2.121a.26.26 0 0 1-.267-.264V2.574zm0 1.544c-.582 0-1.058.478-1.058 1.06 0 .282.113.537.294.727-.491.27-.824.793-.824 1.391-.019.274.051.49.29.53h2.597c.228-.037.275-.27.291-.53a1.59 1.59 0 0 0-.825-1.39 1.05 1.05 0 0 0 .295-.728c0-.582-.478-1.06-1.06-1.06zm0 .53c.296 0 .53.234.53.53 0 .296-.234.53-.53.53s-.528-.234-.528-.53c0-.296.232-.53.528-.53zm0 1.588c.589 0 1.06.472 1.06 1.06H3.181c0-.588.47-1.06 1.058-1.06z"
          fill="#FFFFFF"
          opacity="1"
          data-original="#FFFFFF"
        ></path>
      </g>
    </svg>
  );
};

export default PendingWFH;
